"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUserCircleFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.user-circle_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "user-circle_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "user-circle_filled_svg__transparent_box" }),
        React.createElement("g", { id: "user-circle_filled_svg__FILLED" },
            React.createElement("path", { className: "user-circle_filled_svg__cls-1", d: "M16 19.5c3.33 0 4.69-1.74 4.69-6 0-4.09-1.49-6-4.69-6s-4.69 1.9-4.69 6 1.53 6 4.69 6z" }),
            React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 5.5c3.2 0 4.69 1.9 4.69 6 0 4.27-1.36 6-4.69 6-3.16 0-4.69-2-4.69-6s1.49-6 4.69-6zM16 28a12 12 0 01-9-4.15 23.06 23.06 0 0118.1 0A12 12 0 0116 28z" }))));
}
exports.default = SvgUserCircleFilled;
//# sourceMappingURL=UserCircleFilled.js.map